import { useTranslation } from "react-i18next";
import {
  HOSPITAL_ADDRESS,
  HOSPITAL_NAME,
  HOSPITAL_PHONE,
  LOGO_URL,
} from "../config";

const PrintHeader = ({ showReturnPolicy = false }) => {
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: "center", marginBottom: "15px" }}>
      <img
        src={LOGO_URL}
        alt={HOSPITAL_NAME}
        style={{
          width: "70px",
          height: "auto",
          marginBottom: "8px",
          backgroundColor: "#fff",
          padding: "4px",
        }}
      />
      <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "bold" }}>
        {HOSPITAL_NAME}
      </h2>
      {HOSPITAL_PHONE ? (
        <p style={{ margin: "5px 0", fontSize: "12px", fontWeight: "500" }}>
          {t("print.phone")}: {HOSPITAL_PHONE}
        </p>
      ) : null}
      {HOSPITAL_ADDRESS ? (
        <p style={{ fontSize: "11px", margin: "5px 0", color: "#555" }}>
          {HOSPITAL_ADDRESS}
        </p>
      ) : null}
      {showReturnPolicy ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              margin: "8px 0",
              fontStyle: "italic",
            }}
          >
            {t("print.returnPolicyNote")}
          </p>
        </div>
      ) : null}
      <hr style={{ border: "1px dashed #333", margin: "15px 0" }} />
    </div>
  );
};

export default PrintHeader;
